
<div class="row justify-content-center" *ngIf="showResetPasswordBox">
  <div class="col-md-4  mt-5">
    <div class="card i-box-shadow">
      <h4 class="card-header">Reset Password</h4>
      <div class="card-body" *ngIf="!isSuccessReset">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="username">New Password</label>
            <div class="pwd-tooltip-outer">
              <input type="password" formControlName="NewPassword" id="NewPassword" maxlength="20" autocomplete="off" tabindex="2" (blur)="onblurRequiredPassword()" (focus)="FocusNewPassword($event)" (keyup)="KeyUp_ValidChangePasswordFields($event);passwordMatchValidator()" stopspacebar class="form-control" />
              <div class="pwd-tooltip arrow_box left" *ngIf="!IsPwdValid">
                <h5>Your password must have at least 8 characters, including:</h5>
                <ul>
                  <li>1 Lower case letter 1 upper case letter</li>
                  <li>1 number</li>
                  <li>1 special character from !@@#$%^&*</li>
                </ul>
              </div>
              <div class="ntl-text-required ntl-exlamation-full" *ngIf="spnReqPassword">A password would be helpful.</div>
            </div>
          </div>
          <div class="form-group">
            <label for="username">Confirm Password</label>
            <input type="password" formControlName="confirmPassword" id="tbxConfirmPwd" maxlength="20" (keyup)="passwordMatchValidator()" (blur)="onblurRequiredConfirmPassword()" [ngClass]="{ 'is-invalid':IsPasswordChecker  }" class="form-control" />
            <div class="ntl-text-required ntl-exlamation-full" *ngIf="spnReqConfirmPassword">Confirm the password is right.</div>
            <div class="ntl-text-required ntl-exlamation-full" *ngIf="spnConfirmPassword">Did you type that correctly?</div>
            <div *ngIf="IsPasswordChecker" class="ntl-text-required ntl-exlamation-full">
              Not matched with new password.
            </div>
          </div>
          <div class="form-group">
            <button [disabled]="loading || form.invalid || IsPasswordChecker || !IsPwdValid" class="btn btn-primary">
              <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
              Save
            </button>            
          </div>
        </form>
      </div>
      <div class="card-body" *ngIf="isSuccessReset">
        <div>Your password reset successfully, please login with new password.</div>
        <button class="btn btn-primary mt-3" (click)="returntologin()">Return to login</button>
      </div>
    </div>
  </div>

</div>


<!-- Popup Modal for token expired -->
<div *ngIf="isPopupVisible" class="popup-overlay">
  <div class="popup-content">
    <h5>Your token is expired.</h5>

    <button class="btn btn-primary mt-3" (click)="returntologin()">Return to login</button>
  </div>
</div>

